<template>
  <div>
    <!-- 搜索条件 -->
    <div class="search clear">
      <div class="more_operate">
        <el-dropdown size="mini" split-button type="primary" @click="handleClick">
          更多操作
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>审核不通过</el-dropdown-item>
            <el-dropdown-item>更改首页推荐状态</el-dropdown-item>
            <el-dropdown-item divided>更改站长推荐状态（选中）</el-dropdown-item>
            <el-dropdown-item>审核通过（选中）</el-dropdown-item>
            <el-dropdown-item>关闭（选中）</el-dropdown-item>
            <el-dropdown-item>批量删除（选中）</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <el-form :inline="true" size="mini">
        <el-form-item label="标题">
          <el-input placeholder="标题" clearable></el-input>
        </el-form-item>
        <el-form-item label="类别">
          <el-cascader :options="artType" :props="{ checkStrictly: true }" clearable></el-cascader>
        </el-form-item>
        <el-form-item label="用户id">
          <el-input placeholder="用户id" clearable></el-input>
        </el-form-item>
        <el-form-item label="首页推荐">
          <el-select style="width:100px;" clearable>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select style="width:100px;" clearable>
            <el-option label="审核中" value="0"></el-option>
            <el-option label="审核通过" value="1"></el-option>
            <el-option label="未通过" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-popover
            popper-class="more_search"
            placement="top"
            width="100%"
            v-model="moreSearchVisible"
          >
            <div class="more_search_area clear">
              <ul>
                <li>
                  <span class="label_title">站长推荐</span>
                  <el-select style="width:100px;" clearable>
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                  </el-select>
                </li>
                <li>
                  <span class="label_title">是否原创</span>
                  <el-select style="width:100px;" clearable>
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                  </el-select>
                </li>
              </ul>
            </div>
            <el-tooltip content="更多筛选条件" slot="reference">
              <el-button type="text">
                <i class="el-icon-d-arrow-right"></i>
              </el-button>
            </el-tooltip>
          </el-popover>
        </el-form-item>
        <el-form-item>
          <el-button type="primary">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table">
      <el-table
        :data="tableData"
        size="small"
        height="100%"
        border
        style="width: 100%; height:100%;"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column prop="type" label="类别"></el-table-column>
        <el-table-column prop="userID" label="用户id"></el-table-column>
        <el-table-column prop="userNick" label="昵称"></el-table-column>
        <el-table-column prop="status" label="状态"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="deleteRow(scope.$index, tableData)"
              type="text"
              size="small"
            >编辑</el-button>
            <el-button
              @click.native.prevent="deleteRow(scope.$index, tableData)"
              type="text"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination background layout="prev, pager, next, total" :total="1000"></el-pagination>
    </div>
  </div>
</template>

<script>
import { tableData } from "../../../demo/art/artlist";
export default {
  name: "art_artlist",
  data() {
    return {
      tableData,
      artType: [
        {
          value: 1,
          label: "网页模板",
          children: [
            {
              value: 2,
              label: "文章资讯"
            },
            {
              value: 3,
              label: "医疗保健"
            }
          ]
        }
      ],
      moreSearchVisible: false
    };
  }
};
</script>

<style scoped>
</style>